import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors, types } from "../../../../libs";

export const NotesModal = styled(Modal)`
  .modal-dialog {
    max-width: 700px;
  }
  .modal-content {
    background: transparent;
    border: 0;
  }
`;
export const ModalWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.background.lightBlack};
  border-radius: 8px;
  max-height: 88vh;
  overflow-y: auto;
  scrollbar-color: ${colors.background.darkGreen} transparent;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.background.darkGreen};
    border-radius: 10px;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
`;
export const ModalTitle = styled.div`
  ${types.body.secondaryTitle};
  color: ${colors.text.white};
  font-weight: bold;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
`;
export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.white};
  }
`;
export const AddRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
`;
export const CharacterCount = styled.div`
  ${types.body.small};
  color: ${colors.text.disabled};
`;
export const AddButton = styled.div`
  width: 145px;
`;
export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 22px 0;
`;
export const EmptyNotes = styled.div`
  ${types.body.normal};
  color: ${colors.text.gray};
  text-align: center;
  padding: 28px 10px;
`;
export const NotesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;
const noteColors = ["rgba(184,249,79,.11)", "rgba(255,211,105,.11)", "rgba(112,193,255,.11)"];
const noteBorders = ["rgba(184,249,79,.28)", "rgba(255,211,105,.28)", "rgba(112,193,255,.28)"];
export const StickyNote = styled.div<{ $variant: number }>`
  min-height: 145px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ $variant }) => noteColors[$variant]};
  border: 1px solid ${({ $variant }) => noteBorders[$variant]};
  border-radius: 4px;
`;
export const NoteText = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
export const NoteFooter = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 16px;
`;
export const DeleteButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.red};
  }
  &:disabled {
    opacity: 0.45;
  }
`;
